import EnrollmentRequirementCodebookContainer from '@src/components/codebook/EnrollmentRequirementCodebookContainer';
import React from 'react';

const AdminEnrollmentRequirementCodebookPage = () => <EnrollmentRequirementCodebookContainer />;

export default AdminEnrollmentRequirementCodebookPage;
